/* eslint-disable eqeqeq */
import Vue from 'vue'
// 工具方法
import { nativeRedirect } from '@/utils/native_interactions/native_redirect'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'

// 通用组件
import Tag from '@/common/widgets/good_tag'

// 自定义组件
import goodImage from './widgets/good-image'
import baseInfo from './widgets/base-info'
import goodPrice from './widgets/new-good-price.vue'
import goodPriceBillion from './widgets/new-good-price-billion.vue'
import goodTag from './widgets/new-good-tag.vue'
import goodShop from './widgets/good-shop'

import { GOOD_VIDEO_TYPE } from '@/utils/enum'
// const STATUS_READY_SALE         = 0; //准备开售
// const STATUS_BUY                = 1; //购买
// const STATUS_CROSS_POINT        = 2; //已结束
// const STATUS_SELL_OUT           = 3; //已售罄
// const STATUS_ACTIVITY_NO_START  = 4; //活动未开始
// const STATUS_ACTIVITY_IS_END    = 5; //活动已结束
// const STATUS_OFFLINE            = 6; //下线
// const STATUS_LOOT_ALL           = 7; //已抢光
// const STATUS_HAVE_PARTICIPATE   = 8; //已参与
// const STATUS_SHOP_CLOSE         = 9; //店铺歇业

// eslint-disable-next-line import/no-default-export
export default Vue.extend({
  components: {
    Tag,
    goodImage,
    baseInfo,
    goodPrice,
    goodTag,
    goodShop,
    goodPriceBillion
  },
  props: {
    module: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: 'sole'
    },
    ssu: {
      type: Object,
      default: () => ({})
    },
    skuIndex: {
      type: Number,
      default: 0
    },
    goodWidth: {
      type: Number,
      default: 96
    }
  },
  computed: {
    ssuInfo() {
      return this.ssu.ssuInfo
    },
    // 关于sku和ssu的规格信息 十亿补贴单独处理
    formatInfo() {
      if (this.$options.parent?.module?.performanceType) {
        return this.ssuInfo?.ssuFpText
      }
      return this.ssu?.skuFormats?.skuFormat || ''
    },
    // 是否是促销价
    hasPromote() {
      // eslint-disable-next-line camelcase
      const promoteType =
        this.ssu.ssuInfo?.promotion_remind_info?.promote_type ?? []
      return (
        promoteType.includes(2) || // 普通商品2和购物车3是一个东西
        promoteType.includes(3) ||
        promoteType.includes(4) ||
        promoteType.includes(21) || // 会员价（标签展示），新增类型
        promoteType.includes(12) // 会员 目前不再使用
      )
    },

    // 是否展示划线价
    showOriginalPrice() {
      return this.hasPromote && !!this.ssuInfo?.ssuPrice?.crossedPrice
    },

    // 商品标签
    goodTags() {
      return this?.ssuInfo?.ssuTags || []
    },
    // 过滤美菜标签
    filterSelfTags() {
      // eslint-disable-next-line eqeqeq
      return this.goodTags.filter(item => item.tagType != 214)
    },
    stockStatus() {
      return this?.ssu?.skuImg?.expectArrivedRemind || ''
    },
    isMallAppMp() {
      return window.matrix?.isMiniProgram || window.matrix?.isMallApp
    },
    popShortName() {
      return this.isMallAppMp ? this?.ssu?.popInfo?.shopShowName || '' : ''
    },
    popUrl() {
      return this?.ssu?.popInfo?.popUrl || ''
    },
    isSelfPop() {
      // eslint-disable-next-line eqeqeq
      return this.ssu.popInfo?.popType == 1
    },
    isVideo() {
      const showVideo = this?.ssu?.skuImg?.videoFlag === GOOD_VIDEO_TYPE.NORMAL
      return showVideo
    },
    skuImg() {
      return this?.ssu?.skuImg
    },
    // 左上角图片
    leftUpperTag() {
      const leftUpperTag =
        this?.ssu?.skuImg?.leftUpperTag &&
        this?.ssu?.skuImg?.leftUpperTag.length > 0 &&
        this?.ssu?.skuImg.leftUpperTag[0]
          ? this?.ssu?.skuImg.leftUpperTag[0]
          : ''
      return leftUpperTag
    },
    leftBottomTag() {
      const leftBottomTag =
        this?.ssu?.skuImg?.leftBottomTag &&
        this?.ssu?.skuImg?.leftBottomTag.length > 0 &&
        this?.ssu?.skuImg.leftBottomTag[0]
          ? this?.ssu?.skuImg.leftBottomTag[0]?.tag
          : ''
      return leftBottomTag
    },
    // 右上图标
    RightUpperTag() {
      const rightUpperTag =
        this?.ssu?.skuImg?.rightUpperTag &&
        this?.ssu?.skuImg?.rightUpperTag.length > 0 &&
        this?.ssu?.skuImg.rightUpperTag[0]
          ? this?.ssu?.skuImg.rightUpperTag[0]
          : ''
      return rightUpperTag
    },
    // 右下图标
    RightBottomTag() {
      const rightBottomTag =
        this?.ssu?.skuImg?.rightBottomTag &&
        this?.ssu?.skuImg?.rightBottomTag.length > 0 &&
        this?.ssu?.skuImg.rightBottomTag[0]
          ? this?.ssu?.skuImg.rightBottomTag[0]
          : ''
      return rightBottomTag
    },
    // 中间图标
    CenterTag() {
      const centerTag =
        this?.ssu?.skuImg?.centerTag &&
        Object.keys(this?.ssu?.skuImg?.centerTag).length > 0
          ? this?.ssu?.skuImg?.centerTag
          : ''
      return centerTag
    },
    // 扩展图标
    extraTag() {
      const extraTag =
        this?.ssu?.skuImg?.extraTag &&
        Object.keys(this?.ssu?.skuImg?.extraTag).length > 0
          ? this?.ssu?.skuImg?.extraTag?.tag
          : ''
      return extraTag
    },
    // 不显示大促
    promoteTagPic() {
      return []
    },
    depositInfo() {
      return (
        this.ssuInfo.ssuPrice.depositInfo ||
        this.ssuInfo.ssuPrice.packagePriceMsg ||
        null
      )
    },
    showDisCountTag() {
      if (this.$options?.parent?.module?.performanceType) {
        return true
      }
      const showDisCountTag =
        this?.ssu?.skuImg?.leftUpperTag &&
        this?.ssu?.skuImg?.leftUpperTag.length > 0 &&
        this?.ssu?.skuImg.leftUpperTag[0]
          ? Number(this?.ssu?.skuImg.leftUpperTag[0]?.tagType) === 528
          : false

      return showDisCountTag
    },
    disCountTag() {
      // eslint-disable-next-line eqeqeq
      const disCoutTag = this.goodTags.find(item => item.tagType == 544)
      return disCoutTag
      // return {
      //   backgroundColor: 'yellow',
      //   tag: '折扣'
      // }
    },
    isPerformanceType() {
      return !!this.$options.parent?.module?.performanceType // 十亿补贴
    },
    introduceTags() {
      return this?.ssu?.skuIntroduce?.introduceTags || []
    },
    feedbackTags() {
      return this?.ssu?.skuIntroduce?.feedbackTags || []
    },
    ssuFpText() {
      if (this.$options.parent?.module?.performanceType) {
        return ''
      }
      return this.ssuInfo?.ssuFpText || ''
    },
    bottomTag() {
      return this.ssu?.skuImg?.bottomTag?.[0] || null
    },
    skuAttrTags() {
      return this?.ssu?.skuIntroduce?.skuAttrTags || []
    },
    filterSelfAttrTags() {
      // eslint-disable-next-line eqeqeq
      return this.skuAttrTags.filter(item => item.tagType === 214)
    },
    priceUpperTag() {
      return this?.ssuInfo?.ssuPrice?.priceUpperTag || []
    },
    priceRecommendTag() {
      // 1*N  比上次买降价x元
      const priceRecommendTag = this.priceUpperTag.find(
        item => item?.tagType != 602
      )
      return priceRecommendTag
    },
    priceSaveTag() {
      // 1*N  立省5元
      const priceSaveTag = this.priceUpperTag.find(item => item?.tagType == 602)
      return priceSaveTag
    },
    priceUpperFirstTag() {
      const tag = this.priceUpperTag?.[0]
      if (tag) {
        return {
          textColor: '#fff',
          backgroundColor: 'rgb(255, 62, 0)',
          tag: tag.tag
        }
      }
      // 2*N 3*N 价格上面标签
      return tag
    },
    commonTracerPamas() {
      return {
        sku_pos: this.skuIndex
      }
    }
  },
  methods: {
    // 统一商品模块埋点上报方法
    tracerReport(type) {
      const tickerInfo = this.ssuInfo.tickerInfo
      const commonTracerPamas = this.commonTracerPamas
      if (tickerInfo && tickerInfo[type]) {
        this.$track(
          tickerInfo[type].spm,
          Object.assign(
            {},
            tickerInfo.data,
            tickerInfo[type].spmJson,
            commonTracerPamas
          ),
          this.ssu.extraTrack ? this.ssu.extraTrack : {}
        )
      } else {
        this.$emit(type, this.ssu, this.skuIndex)
      }
    },
    goDetail() {
      this.tracerReport('click')
      // 跳商品详情拼接tickReferId
      const spm = this.ssuInfo?.tickerInfo?.click?.spm || '0.0.0.0'

      nativeRedirect(nativeRoutes.goodsDetail, {
        id: this.ssuInfo.ssuId,
        tickReferId: spm
      })
    },
    // 进店埋点
    goodShopTrack() {
      // 加购埋点
      this.tracerReport('pop')
    },
    addCartTrack() {
      this.$emit('addcart', this.ssu, this.skuIndex)
    }
  }
})
